import type { ReactElement } from 'react';

import type { LucideIcon } from 'lucide-react';

import { KPICard, type KPICardProps } from './KPICard.js';

export interface DashboardKPIStat {
  key: string;
  label: string;
  value: string | number;
  color: string;
  icon?: LucideIcon;
  suffix?: string;
  trend?: number;
}

export interface TodaysStatsProps {
  stats: readonly DashboardKPIStat[];
  testId?: string;
}

export function TodaysStatsWidget({ stats, testId }: TodaysStatsProps): ReactElement {
  return (
    <div
      data-testid={testId}
      style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(6, minmax(0, 1fr))', 
        gap: 16,
        height: '100%',
        width: '100%'
      }}
    >
      {stats.map((metric) => {
        const kpiCardProps = {
          label: metric.label,
          value: metric.value,
          color: metric.color,
          testId: `dashboard-kpi-${metric.key}`,
          ...(metric.icon ? { icon: metric.icon } : {}),
          ...(metric.suffix ? { suffix: metric.suffix } : {}),
          ...(metric.trend !== undefined ? { trend: metric.trend } : {}),
        } satisfies KPICardProps;

        return <KPICard key={metric.key} {...kpiCardProps} />;
      })}
    </div>
  );
}
